import $ from "jquery"

$(document).ready(function() {
    $('.benefits__main-content.active').css('height', ($('.benefits__main-content.active .benefits__box:first-of-type').height() + $('.benefits__main-content.active .benefits__box:nth-of-type(2)').height() + $('.benefits__main-content.active .benefits-footer').height()) +115);
});
$('.js-benefits-accordion').each(function(){
    $(this).on('click', function(){
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).next().removeClass('active');
            $(this).next().css('height', '');
        } else {
            var anchor = $(this);
            $('.js-benefits-accordion').removeClass('active');
            $(this).addClass('active');
            $(this).parent().children('.benefits__main-content').addClass('active');
            $('.benefits__main-content').css('height', '');
            $(this).parent().children('.benefits__main-content').css('height', ($(this).parent().children().children('.benefits__box:first-of-type').height() + $(this).parent().children().children('.benefits__box:nth-of-type(2)').height() + $(this).parent().children().children('.benefits-footer').height()) +115);
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $(anchor).offset().top - 160
                }, 0);
            }, 900);
        }
    });
});

const hash = window.location.hash.substring(1);
const title = $(".js-benefits-title-slider .benefits__thumbnail-item[data-anchor='"+hash+"']");

$(window).on('load', function() {
    if(hash) {
        $('html, body').animate({
            scrollTop: $('#section-benefits').offset().top - 110
        }, 0);

        title.closest('.slick-slide').trigger('click');
    }
});

$('.js-benefits-title-slider .benefits__thumbnail-item').on('click', function() {
    history.pushState({}, '',  '#'+$(this).data('anchor'));
});